import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CustomSelect from '../../../components/UI/CustomSelect';
import CustomButton from '../../../components/UI/CustomButton';
import CustomTable from '../../../components/UI/CustomTable';
import { CellType } from '../../../types/Common';
import useStyles from './useStyles';
import { getReportByType } from '../../../apis/report';
import { selectOptionsJobGroup } from '../../../constants/translate';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'name',
    label: 'نام',
    type: CellType.STRING,
  },
  {
    key: 'lastName',
    label: 'نام خانوادگی',
    type: CellType.STRING,
  },
  {
    key: 'result',
    label: 'نمره',
    type: CellType.FLOAT,
  },
  {
    key: 'testDate',
    label: 'تاریخ انجام آزمون',
    type: CellType.DATE,
  },
  {
    key: 'testId',
    label: 'مشاهده نتیجه آزمون',
    type: CellType.TEST,
  },
];

const JobGroup = () => {
  const classes = useStyles();
  const [selectValue, setSelectValue] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const getReport = () => {
    setLoading(true);
    getReportByType('job_group', selectValue)
      .then((res: any) => setUsers(res || []))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Box className={classes.topContainer}>
        <CustomSelect
          value={selectValue}
          onChange={(value: string) => setSelectValue(value)}
          options={selectOptionsJobGroup}
          placeholder='گروه شغلی'
          fullWidth
        />

        <CustomButton loading={loading} disabled={loading || !selectValue} onClick={getReport}>
          <Typography px={2}>اعمال فیلتر</Typography>
        </CustomButton>
      </Box>

      <Box mt={2}>
        <CustomTable rows={users} tableHead={tableHead} size='small' />
      </Box>
    </>
  );
};

export default JobGroup;
